import { ProductMediaItem, Product } from "../models"
import { PRODUCT_MEDIA_ITEM_TYPES } from "../constants"
import { Api, ListResponse } from "../../api"

import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"
import _ from "lodash"
import * as $ from "jquery"

@Component({ name: "ProductMediaGallery" })
export default class ProductMediaGallery extends Vue {
  @Prop()
  product!: Product

  @Prop()
  rideEnabled!: boolean

  loading = false
  swiped = false
  mediaItemsResponse: ListResponse<ProductMediaItem> | null = null
  activeMediaItem: ProductMediaItem | null = null
  activeItemPersists = false
  lightBoxVisible = false
  itemsPerSlide = 1

  mounted() {
    this.reloadMediaItems()
  }

  async reloadMediaItems(offset = 0, limit = 20) {
    const api = Api.createFromEnv()
    const options = {
      product__eq: this.product._id,
      offset: offset.toString(),
      limit: limit.toString(),
    }

    this.loading = true
    this.mediaItemsResponse = await api
      .getList<ProductMediaItem>("product_media_items", options)
      .catch(error => {
        console.error(error)

        return null
      })

    window.setTimeout(this.setupCarousel, 50)

    this.loading = false
  }

  setupCarousel() {
    $(this.$refs["carousel"]).carousel({
      ride: this.rideEnabled !== undefined ? this.rideEnabled : true,
    })

    $(this.$refs["carousel"]).swipe({
      swipe: (_: any, direction: string) => {
        const carousel = this.$refs["carousel"]

        if (direction == "left") {
          $(carousel).carousel("next")
          this.swiped = true
        } else if (direction == "right") {
          $(carousel).carousel("prev")
          this.swiped = true
        }
      },
      allowPageScroll: "vertical",
    })
  }

  get chunkedMediaItems() {
    return _.chunk(this.mediaItemsResponse?.items || [], this.itemsPerSlide)
  }

  onItemClick(item: ProductMediaItem) {
    if (this.swiped === false) {
      this.activeMediaItem = item
      this.activeItemPersists = !this.activeItemPersists

      this.lightBoxVisible = true
    } else {
      this.swiped = false
    }
  }

  getActiveItemTypeKey() {
    let typeKey: string | null = ""

    if (this.activeMediaItem !== null) {
      typeKey = this.getItemTypeKey(this.activeMediaItem)
    } else {
      typeKey = "image"
    }

    return typeKey
  }

  getActiveItemUri() {
    let uri = this.activeMediaItem?.uri || null

    if (
      uri !== null &&
      this.activeMediaItem !== null &&
      this.getItemTypeKey(this.activeMediaItem) === "embedded_video"
    ) {
      if (uri.indexOf("youtube") > -1) {
        const srcRegex = new RegExp('(?<=src=").*?(?=[*"])')
        const matches = uri.match(srcRegex)

        if (matches !== null && matches.length > 0) {
          const srcUrl = matches[0]
          const newSrcUrl = `${srcUrl}${
            srcUrl.indexOf("?") > -1 ? "&" : "?"
          }autoplay=1`

          uri = uri.replace(srcRegex, newSrcUrl)
        }
      }
    }

    return uri
  }

  getItemTypeKey(item: ProductMediaItem): string | null {
    return _.get(
      _.find(PRODUCT_MEDIA_ITEM_TYPES, { id: item.type }),
      "key",
      null,
    )
  }

  onCloseLightboxClick() {
    this.lightBoxVisible = false
  }

  getPaddingClassForItemAtIndex(index: number) {
    let className = ""
    const basePadding = 4

    if (index < this.itemsPerSlide - 1) {
      className = `mb-${basePadding} mb-md-0`
    }

    return className
  }
}
